<template>
  <div class="member__video">
    <div class="title">{{ activeTab === 30 ? '学习视频' : '时政解读' }}</div>
    <div v-if="activeTab === 20" class="shizheng" @click="goStudy(1)">
      <div class="shizheng__text">{{ !isUnlock ? '更多时政解读内容，开通会员卡即可解锁' : '已解锁时政解读课程，课程内容会不定期更新，请关注！' }}</div>
    </div>
    <div class="study__video" v-if="activeTab === 30">
      <div class="card item1" @click="goStudy(1)">
        <div class="top">
          <span class="dot"></span>
          <span class="text">时政解读</span>
        </div>
        <div class="desc">{{ !isUnlock ? '更多时政解读内容，开通会员卡即可解锁' : '已解锁时政解读课程，课程内容会不定期更新，请关注！' }}</div>
        <div class="icon"></div>
      </div>
      <div class="card item2" @click="goStudy(2)">
        <div class="top">
          <span class="dot"></span>
          <span class="text">专题视频</span>
        </div>
        <div class="desc">{{ isUnlock ? '已' : '' }}解锁vip专属视频</div>
        <div class="icon"></div>
      </div>
    </div>

  </div>
</template>

<script>
import { whatEev } from '@/utils/tools';
import wx from 'weixin-js-sdk';
import { reqSchemeUrl } from '@/api/openMini';
import {
  getTaskApi,
  reqIsBuyProduct,
} from '@/api/member/index';

export default {
  props: {
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    activeTab: {
      type: Number,
      value: 20,
    },
    userMemberInfo: {
      type: Object,
      default: () => ({
        level: 0, // 0 普通用户 10 试用会员 20 普通会员 30 高级会员
        levelName: '普通用户',
        deadlineStartTime: '',
        deadlineEndTime: '', // 会员到期时间
        isTryoutMember: null, // 是否领取过试用会员
        beforeMemberLevel: null, // 上一次会员等级
      }),
    },
    productId: {
      type: String,
      default: '',
    },
  },
  methods: {
    goStudy(key) {
      if (key === 1) {
        this.goCourseDetail();
      } else {
        this.goCourse();
      }
    },
    // 跳转课程详情
    goCourseDetail() {
      if (this.isUnlock) { // 跳转导学页面
        this.goGuide(this.productId);
        return;
      }
      // 跳转对应的详情页面
      if (whatEev() === 'miniprogram') {
        let url = window.location.href;
        const { origin } = window.location;
        // eslint-disable-next-line no-unused-vars
        const [domain, searchParams] = url.split('?');
        const params = searchParams.split('&');
        const paramsMap = new Map();
        params.forEach((item) => {
          const [key, value] = item.split('=');
          if (key) {
            paramsMap.set(key, value);
          }
        });
        const entries = paramsMap.entries();
        let query = '';
        const ExcludequeryArr = ['THIRD_SESSION', 'env'];
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of entries) {
          if (ExcludequeryArr.includes(key)) query += `${key}=${value}&beforePageName=8`;
        }
        url = `${origin}/ark/courseDetail?courseId=${this.productId}&${query}`;
        const path = `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}&isNeedLogin=0`;
        wx.miniProgram.navigateTo({
          url: path,
        });
      } else if (this.$root.$data.isApp) {
        this.$sendToApp('goCourseDetail', Number(this.productId), false);
      } else {
        this.$router.push({
          path: '/courseDetail',
          query: {
            courseId: this.productId,
            beforePageName: 8,
          },
        });
      }
    },
    // 跳转导学页面
    async goGuide(productId) {
      const info = await reqIsBuyProduct(productId);
      if (info.code === 0 && info?.data?.length) {
        const { id } = info?.data?.[0];
        const res = await this.entranceTask(id);
        if (res === 'unFinished') {
          if (this.$root.miniprogram) {
            this.$toast('请前往app完成入学任务后，即可查看课程视频');
          } else if (this.$root.$data.isApp) {
            const { origin } = window.location;
            const url = `${origin}/ark/entranceTask?id=${id}`;
            this.$sendToApp('openNewWebView', { url }, false);
          } else {
            this.$router.push({
              path: '/entranceTask',
              query: {
                id,
              },
            });
          }
        } else if (res === 'finished') {
          if (this.$root.miniprogram) {
            wx.miniProgram.navigateTo({ url: `/myCourse/learningGuide/index?catalogId=${id}` });
          } else if (this.$root.$data.isApp) {
            this.$sendToApp('goDirectoryPage', { courseId: id }, false);
          } else {
            this.$router.push({
              path: '/learningGuide',
              query: {
                catalogId: id,
              },
            });
          }
        }
      }
    },
    async entranceTask(id) {
      const { code, data } = await getTaskApi(id);
      if (code === 0) {
        const {
          agreementId, agreementDone, examId, examDone, examinationFlag, examinationDone,
        } = data;
        this.examId = examId;
        if (
          (agreementId && !agreementDone) || (examId && !examDone) || (examinationFlag && !examinationDone)
        ) {
          return 'unFinished';
        }
        return 'finished';
      }
      return 'err';
    },
    goCourse() {
      if (whatEev() === 'miniprogram') {
        wx.miniProgram.switchTab({
          url: '/pages/course/course',
        });
      } else if (this.$root.$data.isApp) {
        this.$sendToApp('goToHomePage');
      } else {
        this.$router.push({
          path: '/exam25',
          query: {
            code: 10,
          },
        });
      }
    },
    // h5 打开小程序的方法
    async getSchemeUrl(path) {
      const data = {
        appid: 'wxdb89cfa2bb60f779',
        path,
        envVersion: !window.location.host.includes('mobile-test') ? 'release' : 'trial',
      };
      const res = await reqSchemeUrl(data);
      if (res?.code === 0) {
        this.chatUrl = res.data;
        window.location.href = res.data;
      }
    },
  },
  computed: {
    isUnlock() {
      const { level } = this.userMemberInfo;
      const { id } = this.userInfo;
      const flag = id && ((level === 30 && this.activeTab === 30) || ([10, 20, 40, 50, 60].includes(level) && this.activeTab === 20));
      return !!flag;
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../index.scss';

.member__video {
  width: 678px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 auto 36px;
}

.title {
  width: 100%;
  margin-bottom: 22px;
  height: 40px;
  font-size: 29px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 40px;
}

.study__video {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.shizheng {
  @include background(678px, 138px);
  @include backgroundImage('member_shizheng1.png');
  padding: 76px 29px 0;

  .shizheng__text {
    font-size: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 31px;
  }
}

.card {
  width: 330px;
  height: 168px;
  background: #FFFFFF;
  border-radius: 14px;
  padding: 22px 0 0 25px;
  position: relative;
}

.top {
  display: flex;
  height: 40px;
  align-items: center;

  .dot {
    display: inline-block;
    width: 5px;
    height: 18px;
    border-radius: 3px;
    position: relative;
    margin-right: 7px;
  }

  .text {
    font-size: 29px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 40px;
  }
}

.desc {
  margin-top: 16px;
  ;
  font-size: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 31px;
}

.item1 .dot {
  background: rgba(255, 127, 65, 1);
}

.item2 .dot {
  background: rgba(74, 119, 255, 1);
}

.icon {
  @include background(83px, 87px);
  position: absolute;
  top: 0;
  right: 0px;
}

.item1 .icon {
  @include backgroundImage('member_video1.png');
}

.item2 .icon {
  @include backgroundImage('member_video2.png');
}
</style>
